const state = {
    userType: '',
    userCountry: ''
};

export default state;